import { RequestConfig } from '../types'
import { AxiosResponse } from 'axios'
import { AxiosAPI } from './AxiosApi'

class EpaApiClass extends AxiosAPI {
  public getAnalyteClasses = async (options: RequestConfig = {}) => {
    return await this.GET(this.apiSchema.GET.analyte.classes(), options)
  }
  public getAnalyteClass = async (id: string, options: RequestConfig = {}) => {
    return await this.GET(this.apiSchema.GET.analyte.class(id), options)
  }
  public getAnalyteParameterByClassId = async (id: string, options: RequestConfig = {}) => {
    return await this.GET(this.apiSchema.GET.analyte.parameterByClassId(id), options)
  }
  public getAnalyteParameters = async (options: RequestConfig = {}) => {
    return await this.GET(this.apiSchema.GET.analyte.parameters(), options)
  }
  public getAnalyteParameter = async (id: string, options: RequestConfig = {}) => {
    return await this.GET(this.apiSchema.GET.analyte.parameter(id), options)
  }
  public getAppliances = async (options: RequestConfig = {})=> {
      return await this.GET(this.apiSchema.GET.appliances.all(), options)
  }
  public getPubWaterSystem = async(id: string, options: RequestConfig = {}) => {
    return await this.GET(this.apiSchema.GET.pubWaterSystems.pubWaterSystem(id), options)
  }
  public getPWSEventMilestones = async(id: string, options: RequestConfig = {}) => {
    return await this.GET(this.apiSchema.GET.pubWaterSystems.eventMilestones(id), options)
  }
  public getPWSEventMilestonesWDesc = async(id: string, options: RequestConfig = {}) => {
    return await this.GET(this.apiSchema.GET.pubWaterSystems.eventMilestonesWDesc(id), options)
  }
  public getViolationEnforcements = async(id,options: RequestConfig = {}) => {
    return await this.GET(this.apiSchema.GET.pubWaterSystems.violationEnforcements(id), options)
  }

  // Methods consolidated from DashboardApi

  public fetchViolationsEnforcementsGroupedByViolation = async(id, options = {}) => {
    return await this.GET(this.apiSchema.GET.violationEnforcements.byPwsId.grouped.byViolation(id), options)
  }

  public fetchAmericanStates = async (options = {}) => {
    const response = await this.GET(this.apiSchema.GET.waterSystems.americanStates(), options);
    return response as AxiosResponse;
  };

  public fetchWaterSystemsMetrics = async (options = {}) => {
    return await this.GET(this.apiSchema.GET.waterSystems.publicWaterSystemMetrics(), options);
  };

  public fetchWellWaterSystemsMetrics = async (options = {}) => {
    return await this.GET(this.apiSchema.GET.waterSystems.wellWaterSystemMetrics(), options);
  };

  public fetchMapWaterSystemsMetrics = async (options = {}) => {
    return await this.GET(this.apiSchema.GET.waterSystems.mapPublicWaterSystemMetrics(), options);
  };

  public fetchMapWellWaterSystemsMetrics = async (options = {}) => {
    return await this.GET(this.apiSchema.GET.waterSystems.mapWellWaterSystemMetrics(), options);
  };

  public fetchWaterSystems = async (zips: string, options = {}) => {
    return await this.GET(this.apiSchema.GET.waterSystems.publicWaterSystems(zips), options);
  };

  public fetchWellWaterSystems = async (zips: string, options = {}) => {
    return await this.GET(this.apiSchema.GET.waterSystems.wellWaterSystems(zips), options);
  };

  public fetchPublicWaterSystemsByAddress = async (latitude: number, longitude: number, radius?: number, options = {}) => {
    return await this.GET(this.apiSchema.GET.waterSystems.publicWaterSystemsByAddress(latitude, longitude, radius), options);
  };

  public fetchPublicWaterSystemsByAddressComponent = async (city: string, state: string, zipCode: string, address1: string, options = {}) => {
    return await this.GET(this.apiSchema.GET.waterSystems.publicWaterSystemsByAddressComponent(city, state, zipCode, address1), options);
  };

  public fetchUtilityDetail = async (pwsid: string, options = {}) => {
    return await this.GET(this.apiSchema.GET.waterSystems.UtilityDetails(pwsid), options);
  };

  public fetchAggregatedWaterSystems = async (
    zoomLevel: string,
    stateCode?: string,
    options = {},
  ) => {
    return await this.GET(
      this.apiSchema.GET.waterSystems.publicWaterSystemAggregates(zoomLevel, stateCode),
      options,
    );
  };

  public fetchAggregatedWellWaterSystems = async (
    zoomLevel: string,
    stateCode?: string,
    stateName?: string,
    options = {},
  ) => {
    return await this.GET(
      this.apiSchema.GET.waterSystems.wellWaterSystemAggregates(zoomLevel, stateCode, stateName),
      options,
    );
  };

  public createWaterSystemCoordinates = async (body: any, options = {}) => {
    return await this.PUT(this.apiSchema.PUT.waterSystems.publicWaterSystemCoordinates(), body, options);
  };

  public createWellWaterSystemCoordinates = async (body: any, options = {}) => {
    return await this.PUT(this.apiSchema.PUT.waterSystems.wellWaterSystemCoordinates(), body, options);
  };

  public createWaterSystemGeoBlocks = async (body: any, options = {}) => {
    return await this.PUT(this.apiSchema.PUT.waterSystems.wellWaterSystemGeoBlocks(), body, options);
  };

  public uploadWaterTestStrip = async (body: any, options = {}) => {
    return await this.POST(
      this.apiSchema.POST.waterTestStrips.upload(),
      body,
      options
    );
  };

  public getParameters = async (options = {}) => {
    return await this.GET(this.apiSchema.GET.waterTestParams.parameters(), options);
  }

  public getParameterDetails = async (parameterName: string, options = {}) => {
    return await this.GET(this.apiSchema.GET.waterTestParams.parameterDetails(parameterName), options);
  };

  public getWaterTestStripResult = async (jobId: string, options = {}) => {
    return await this.GET(this.apiSchema.GET.waterTestStrips.result(jobId), options);
  };
}

const domain =
  (window.__ENV__ && window.__ENV__?.GATEWAY_API_URL !== '__GATEWAY_API_URL__' && window.__ENV__?.GATEWAY_API_URL) ||
  (window.__ENV__ && window.__ENV__?.EPA_SERVER_API_URL !== '__EPA_SERVER_API_URL__' && window.__ENV__?.EPA_SERVER_API_URL) ||
  (window.__ENV__ && window.__ENV__?.API_URL !== '__API_URL__' && window.__ENV__?.API_URL) ||
  process.env.REACT_APP_EPA_SERVER_API_URL ||
  process.env.REACT_APP_API_URL ||
  ''
export const EpaApi = new EpaApiClass(domain)
